import { Call } from "@twilio/voice-sdk";
import { cn } from "@tellescope/ui";
import { IncomingCallItem } from "./IncomingCallItem";

export interface IncomingCallViewProps {
  /** List of incoming calls */
  incomingCalls: Call[];
  /** Callback when a call is answered */
  onAnswer: (call: Call) => void;
  /** Callback when a call is rejected */
  onReject: (call: Call) => void;
  /** Additional className for the container */
  className?: string;
}

/**
 * IncomingCallView - Displays incoming calls with accept/reject buttons.
 *
 * Shows a list of incoming calls with caller information and action buttons.
 * Each call can be individually answered or rejected.
 *
 * @example
 * ```tsx
 * <IncomingCallView
 *   incomingCalls={incomingCalls}
 *   onAnswer={handleAnswer}
 *   onReject={handleReject}
 * />
 * ```
 */
export const IncomingCallView = ({ incomingCalls, onAnswer, onReject, className }: IncomingCallViewProps) => {
  if (incomingCalls.length === 0) {
    return null;
  }

  return (
    <div className={cn("divide-y", className)}>
      {incomingCalls.map((call, index) => (
        <IncomingCallItem key={call.parameters?.CallSid ?? index} call={call} onAnswer={onAnswer} onReject={onReject} />
      ))}
    </div>
  );
};
